<template>
  <div
    class="productSort"
    style="padding: 0 12px; color: #000; background: #f5f5f8"
  >
    <div class="home_tit">
      <div class="home_tit_top" style="background: #f5f5f8">
        <div
          style="
            background: var(--bg-color);
            border-radius: 10px;
            display: flex;
            align-items: center;
            height: 45px;
            width: 100%;
            padding: 0 15px;
          "
        >
          <input
            @input="shuru"
            v-model="input"
            type="text"
            :placeholder="$t('m.zx_span0')"
            style="
              font-size: 13px;
              height: 30px;
              line-height: 30px;
              padding-left: 14px;
              background: #fff;
              flex: 1;
              border-radius: 10px;
            "
          />
          <div
            style="
              width: 30px;
              height: 30px;
              border-radius: 10px;
              background: #fff;
              margin-left: 10px;
            "
          >
            <img
              src="../../assets/images/new/sou.png"
              style="width: 20px; height: 20px; margin: 5px"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <van-tabs swipeable animated v-if="category" style="margin-top: 60px">
      <van-tab
        v-for="(items, index) in category"
        :key="index"
        :title="items.name"
      >
        <div class="productSort_con">
          <div class="productSort_con_list">
            <div style="padding-top: 0px">
              <div
                class="productSort_block"
                style="
                  padding-top: 7px;
                  padding-left: 10px;
                  padding-right: 10px;
                  padding-bottom: 10px;
                  background: #fff;
                "
                v-for="(item, index) in items.list"
                :key="index"
                @click="details(item.id)"
              >
                <div
                  style="
                    font-size: 15px;
                    font-weight: 500;
                    color: #333;
                    padding: 0 0px;
                    margin-top: 5px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <div class="line-clamp1">
                    {{ item.title }}
                  </div>
                  <div class="day-item" v-if="item.clock != 1">
                    {{ item.day }}{{ $t("m.day") }}
                  </div>
                  <p
                    class="productSort_block_left_dm"
                    :style="{
                      border:
                        item.additional == 1
                          ? '1px solid #FF2500'
                          : '0px solid #FF2500'
                    }"
                    style="
                      border: 1px solid #ff2500;
                      color: #ff2500;
                      padding: 1px 5px;
                      border-radius: 2px;
                      margin-left: 10px;
                      font-size: 10px;
                      border-radius: 3px;
                    "
                  >
                    {{ item.additional == 1 ? $t("m.shouyiguo") : "" }}
                  </p>
                  <template v-if="item.clock == 1">
                    <img
                      src="../../assets/images/licai/naozhong.png"
                      style="width: 25px; height: 25px; margin-left: 15px"
                      alt=""
                    />
                    <van-count-down
                      :time="item.end"
                      format="DD 天 HH 时 mm 分 ss 秒"
                    />
                  </template>
                  <img
                    v-if="item.additional == 1"
                    src="../../assets/images/licai/shouyi.png"
                    style="width: 25px; height: 25px; margin-left: 15px"
                    alt=""
                  />
                </div>
                <div class="project-cover" v-if="item.image">
                  <img :src="coverUrl(item.image)" alt="" />
                </div>
                <div>
                  <span class="zzsy" v-show="Number(item.added) > 0"
                    >增值收益</span
                  >
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                ></div>
                <div
                  style="
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    height: 90px;
                    padding-top: 10px;
                    justify-content: space-between;
                  "
                >
                  <!--平均收益-->
                  <div style="text-align: center">
                    <div
                      style="
                        font-size: 24px;
                        color: #ff2500;
                        font-weight: bold;
                        line-height: 25px;
                      "
                    >
                      {{ item.rate }}<span style="font-size: 13px">%</span>
                    </div>
                    <div style="font-size: 13px; color: #666; margin-top: 3px">
                      {{ $t("m.rishouyi") }}
                    </div>
                  </div>
                  <!--投资-->
                  <div style="font-size: 13px; color: #666; margin-top: 3px;">
                    <div style="display: flex;flex-direction: row">
                      <div>起投投资</div>
                      <div style="color: red">{{ item.min }} 元</div>
                    </div>
                    <div style="display: flex;flex-direction: row">
                      <div>最高投资</div>
                      <div>{{ item.max }} 元</div>
                    </div>
                    <div
                      style="display: flex;flex-direction: row"
                      v-if="item.gift > 0"
                    >
                      <div>红包金额</div>
                      <div style="color: red">{{ item.gift }} 元</div>
                    </div>
                  </div>
                  <!--                  按钮-->
                  <div class="btn-tt">投资</div>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    padding: 0 0px;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      height: 6px;
                      background-color: #f3f0f6;
                      border-radius: 5px;
                      overflow: hidden;
                    "
                  >
                    <div
                      style="
                        background-color: var(--bg-color);
                        height: 100%;
                        border-radius: 6px;
                        transition: width 1.5s;
                      "
                      :style="{ width: item.schedule + '%' }"
                    ></div>
                  </div>
                  <span style="font-size: 12px; color: #666; margin-left: 10px"
                    >{{ item.schedule }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <div style="height: 60px"></div>
  </div>
</template>
<script>
import Socket from "@libs/chat";

var vm = null;
import $store from "../../store";
import { getCategory } from "@api/store";
import { VUE_APP_API_URL } from "@utils/index";
import "@assets/css/swiper.min.css";
import prod from "@/api/ages.json";

export default {
  name: "GoodsClass",
  components: {},
  props: {},
  computed: {
    huilv: function() {
      return $store.state.app.huilv;
    }
  },
  watch: {
    huilv: "gaibian"
  },
  data: function() {
    return {
      input: "",
      socket: null,
      currentRate0: 30,
      currentRate1: 30,
      jinyin: {
        jin: 1.0004,
        type1: true,
        fudu1: "+0.0002",
        min1: "1.0000",
        max1: 1.0004,
        bfb1: "-0.0001%",
        yin: 6.35,
        type2: false,
        fudu2: -0.06,
        bfb2: "-0.07%",
        xin: 6.34,
        type3: true,
        fudu3: +0.03,
        bfb3: "+0.04%"
      },
      sj: true,
      gglist: [],
      shangsheng: require("@/assets/images/new/shangsheng.png"),
      xiajiang: require("@/assets/images/new/xiajiang.png"),
      swiperOption: {
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          click: function() {
            const realIndex = this.realIndex;

            vm.dianjilb(realIndex);
          }
        }
      },
      image:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F015ef657bc11150000012e7eafa2e0.png%402o.png&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1634556413&t=2fb650f58dfd37bf68e8ffd138c2dc73",
      category: prod.data,
      linshi: null,
      navActive: 0,
      search: "",
      remen: [],
      lock: false,
      tabbers: 0,
      // 商品选择类型
      selectList: [
        {
          id: 0,
          tit: "新手专区"
        },
        {
          id: 1,
          tit: "热门投资"
        },
        {
          id: 2,
          tit: "0-3个月"
        },
        {
          id: 3,
          tit: "3个月以上"
        }
      ],
      reRender: true,
      // 商品列表
      productList: [
        {
          id: 0,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        },
        {
          id: 1,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        },
        {
          id: 2,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        },
        {
          id: 3,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        }
      ]
    };
  },

  activated() {
    this.reRender = false;
    setTimeout(() => {
      this.reRender = true;
    }, 10);
  },
  mounted: function() {
    this.socket = new Socket();
    this.socket.vm(this);

    this.$on("onMessage", data => {
      this.jinyinIndex = 1;

      if (data.code) {
        if (data.code == "0" && data.data.length > 0) {
          if (data.data[0].usdCny) {
            let cny = data.data[0].usdCny;
            let cce = (cny * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            if (this.jinyin.xin <= cny) {
              this.jinyin.type3 = true;
            } else {
              this.jinyin.type3 = false;
            }
            this.jinyin.yin = cce;
            this.jinyin.xin = cny;
          }
        }
      }
      if (data.arg) {
        if (data.arg.channel == "tickers" && data.arg.instId == "USDT-USDK") {
          if (data.data.length > 0) {
            if (this.jinyin.jin <= data.data[0].last) {
              this.jinyin.type1 = true;
            } else {
              this.jinyin.type1 = false;
            }
            this.jinyin.jin = data.data[0].last; //最新价
            this.jinyin.max1 = data.data[0].high24h; //最高价
            this.jinyin.min1 = data.data[0].low24h; //最低价
            let kai = data.data[0].open24h; //开盘价
            let cha = (this.jinyin.jin - kai).toFixed(4);
            if (cha >= 0) {
              this.jinyin.fudu1 = "+" + cha;
              this.jinyin.bfb1 = "+" + (cha / kai).toFixed(4) + "%";
            } else {
              this.jinyin.fudu1 = cha;
              this.jinyin.bfb1 = (cha / kai).toFixed(4) + "%";
            }

            let cce = (this.jinyin.yin * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            this.jinyin.yin = cce;
          }
        }
      }

      let huilv = this.jinyin.jin * this.jinyin.yin;
      let ss = $store.state.app.huilv;
      if (huilv >= ss) {
        this.shangxia = true;
      } else {
        this.shangxia = false;
      }
      this.$store.commit("HUILV", huilv);
    });
    this.$on("socket_error", () => {
      // this.$dialog.error("连接失败");
    });
    this.$on("err_tip", data => {
      // this.$dialog.error(data.msg);
    });
    this.$on("socket_open", () => {
      // this.$dialog.error("连接成功");
    });

    this.$nextTick(function() {
      getCategory().then(res => {
        let category = res.data.data;
        console.log("-> category", category);
        let list = [];
        this.category = [];
        for (let i = 0; i < category.length; i++) {
          let dic = category[i].list.map(v => {
            v.schedule = Number(v.schedule).toFixed(3);
            return v;
          });
          list = list.concat(dic);
        }
        category.push({ list: list, name: "全部" });
        this.category = JSON.parse(JSON.stringify(category));
        this.linshi = JSON.parse(JSON.stringify(category));
      });
    });
  },
  created() {
    vm = this;
  },
  methods: {
    coverUrl(url) {
      if (!url) return "";
      if (/^https?:\/\//i.test(url)) return url;
      let host = ($store.state.app.fwq || VUE_APP_API_URL || "").replace(
        /\/$/,
        ""
      );
      if (!/^https?:\/\//i.test(host)) {
        const protocol =
          typeof window !== "undefined" ? window.location.protocol : "https:";
        host = protocol + "//" + host.replace(/^\/\//, "");
      }
      return host + (url.charAt(0) === "/" ? url : "/" + url);
    },
    gaibian(val, olVal) {
      console.log("新：" + val);
      console.log("旧：" + olVal);
      // console.log(this)
      if (val > olVal) {
        this.fangfa(true);
      } else {
        this.fangfa(false);
      }
    },
    fangfa(e) {
      this.sj = e;
    },
    shuru() {
      console.log(this.linshi);
      let zifu = this.input;
      let linshi = JSON.parse(JSON.stringify(this.linshi));
      if (zifu == "") {
        this.category = linshi;
      } else {
        let list = linshi;
        for (let i = 0; i < list.length; i++) {
          let dic = list[i].list;
          let arr = [];
          for (let j = 0; j < dic.length; j++) {
            const cc = dic[j];
            if (cc.title.indexOf(zifu) != -1) {
              arr.push(cc);
            }
          }
          list[i].list = arr;
        }
        this.category = list;
      }
    },
    dianjilb(e) {
      this.$router.push({
        path: "/detail/" + this.remen[e].id
      });
    },
    details: function(id) {
      this.$router.push({
        path: "/detail/" + id
      });
    },
    goTo() {
      this.$router.push({
        path: "/article"
      });
    },
    xiangqing: function() {
      this.$router.push({
        path: "/goods_evaluate/10"
      });
    },
    qiehuan: function(tabs) {
      this.tabbers = tabs;
    }
  }
};
</script>
<style scoped lang="less">
.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  height: 50px;
  padding: 0 15px;
  display: flex;
  align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #333;
  font-weight: bold;
  font-size: 22px;
}

.home_tit_middle img {
  width: 15px;
  height: 15px;
  margin-left: 7px;
}

.home_tit_right {
  padding-right: 10px;
  width: 50%;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 7px;
}

.line-clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.productSort_block_left_xh {
  max-width: 220px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*禁止换行*/
  text-overflow: ellipsis; /*省略号*/
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
}

.productSort_block_left_dm {
  border: 0px solid #ffa68c;
  color: #ffa68c;
  padding: 2px 5px;
  border-radius: 2px;
  font-size: 11px;
}

/deep/ .van-circle__text {
  color: #666;
  font-size: 13px;
}

.productSort_block_last {
  padding: 0px 0px;
  align-items: center;
  display: flex;
}

.productSort_block_last_item:last-child {
  margin-left: 60px;
}

.productSort_block_left {
  display: flex;
  align-items: center;
  padding: 0 0px;
  margin-bottom: 6px;
  // justify-content: space-between;
}

.productSort_con_list {
  margin-top: 0px;
  // background-color: #fff;
  padding: 0 0px;

  overflow: scroll;
  border-radius: 10px;
}

.productSort_block {
  position: relative;

  width: 100%;
  background-color: #ffffff;
  padding: 10px 5px;
  padding-bottom: 5px;
  margin-bottom: 10px;
  border-radius: 10px;
  border-bottom: 0px solid #eee;
}

.productSort_block:last-child {
  border-bottom: 0px solid #eee;
}

.productSort_block img {
  width: 100%;
  height: 86px;
}

.productSort_top {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0 6px;
  /* justify-content: space-between; */
}

.productSort {
  // background: url(../../assets/images/bg233.png) no-repeat;
  background-size: 100% 165px;
}

.productSort_top_block {
  flex-shrink: 0;

  display: inline-block;
  margin-right: 14px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  text-align: center;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
}

.productSort_top_blocks {
  border-bottom: 2px solid #007aff;
  color: #007aff;
}

/deep/ .van-tabs__nav {
  background-color: #f5f5f8 !important;
  overflow: scroll;
}

/deep/ .van-tab {
  height: 20px;
  font-weight: 600;
  font-size: 13px;
  border-right: 1px solid #eee;
  flex: none;
  min-width: 20%;
  // margin-right: 10px;
}

.van-tab--active .van-tab:last-child {
  border-right: 0px solid #fff !important;
}

/deep/ .van-tab--active {
  color: #000;
  font-size: 14px;
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 0px;
  height: 50px;
  box-sizing: border-box;
}

/deep/ .van-tabs__wrap {
  height: 34px;
}

/deep/ .van-tabs__line {
  min-width: 15%;
  top: 28px;
  background: var(--bg-color);
}

/deep/ .swiper-pagination-bullet {
  border: 1px solid #ff3738;
  background: #fff;
}

/deep/ .swiper-pagination-bullet-active {
  // 这以下的代码是你需要的
  background: #ff3738;
  border: 0px solid #ff3738;
}

/deep/ .van-tabs__nav--line.van-tabs__nav--complete {
  padding-left: 0;
  padding-right: 0;
}

.day-item {
  background: #f44336;
  color: #fff;
  padding: 2px 7px;
  font-size: 13px;
  font-weight: 400;
  border-radius: 7px;
  margin-left: 5px;
}

.btn-tt {
  background: #0372fb;
  color: #fff;
  padding: 4px 15px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 16px;
  margin-left: 5px;
  line-height: 25px;
  height: 31px;
}

.zzsy {
  background: #fff4d5;
  color: #ff9800;
  padding: 3px 6px;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
  margin-right: 6px;
  border: 1px solid #ff9800;
}

.project-cover {
  width: 100%;
  margin: 8px 0 4px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
}

.project-cover img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 160px;
  object-fit: cover;
}
</style>
